<script setup lang="ts">
const { t } = useTexts();

useSeo({
  title: t('account.history.poker.title'),
});
</script>

<template>
  <UserAccountPageLayout
    on-back="user-history"
    :title="$t('account.history.poker.title')"
  >
    <div :class="$style.walletTransactions">
      <div class="alert alert-warning">
        {{ $t('account_menu.soon') }}
      </div>
      <!-- <UserWalletTransactions /> -->
    </div>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.walletTransactions {
  @apply w-full h-auto m-0 max-w-[792px];
}
</style>
